export function createQueryObject(inputFields:any ) :object
{
    const query = {};
    Object.entries(inputFields).forEach(([key, value]) => {
        query[key] = value.default_value;
    });
    return query;
}